import { call, put, delay, takeLatest } from 'redux-saga/effects';
import actions, { Types } from '~/store/ducks/transactions';
import snackbar from '../ducks/snackbar';
import api from '~/services/api';

function* loadTransactions({ partner, params }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/transactions`,
      {
        params
      }
    );
    yield put(actions.loadTransactionsSuccess(data));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* loadMoreTransactions({ partner, params }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/transactions`,
      {
        params
      }
    );
    yield put(actions.loadMoreTransactionsSuccess(data));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* loadTransaction({ partner, transaction }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/transactions/${transaction}`
    );
    yield put(actions.loadTransactionsSuccess(data));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* cancelTransaction({ partner, order }) {
  try {
    const { data } = yield call(
      api.put,
      `/v1/partners/${partner}/orders/${order}/void`
    );

    yield put(actions.cancelTransactionSuccess(data));

    yield put(
      snackbar.showSnackbar({
        color: 'success',
        icon: 'check',
        text: 'transaction.cancel.success'
      })
    );

    yield delay(5000);
    yield put(snackbar.hideSnackbar());
  } catch (e) {
    console.error('ERROR: ', e);

    yield put(
      snackbar.showSnackbar({
        color: 'danger',
        icon: 'alert-circle',
        text: 'transaction.cancel.error'
      })
    );

    yield delay(5000);
    yield put(snackbar.hideSnackbar());
  }
}

function* exportTransactions({ partner, params }) {
  try {
    const { data } = yield call(
      api.post,
      `/v1/partners/${partner}/transactions/export`,
      params
    );

    yield put(actions.exportTransactionsSuccess());

    const blob = new Blob([data], { type: 'text/csv;charset=utf-8' });
    const link = document.createElement('a');

    link.href = window.URL.createObjectURL(blob);
    link.download = `transactions-${new Date().getTime()}.csv`;
    link.click();
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

const sagas = [
  takeLatest(Types.LOAD_TRANSACTIONS, loadTransactions),
  takeLatest(Types.LOAD_MORE_TRANSACTIONS, loadMoreTransactions),
  takeLatest(Types.LOAD_TRANSACTION, loadTransaction),
  takeLatest(Types.CANCEL_TRANSACTION, cancelTransaction),
  takeLatest(Types.EXPORT_TRANSACTIONS, exportTransactions)
];

export default sagas;
